import { Obj } from "./types";

export class Fee{
    domestic_transaction_fee?: number;
    international_transaction_fee?:number;
    transaction_fee?: number;

    constructor({
        domestic_transaction_fee,
        international_transaction_fee,
        transaction_fee,
      }: Obj) {
        if (domestic_transaction_fee !== undefined) this.domestic_transaction_fee = domestic_transaction_fee;
        if (international_transaction_fee !== undefined) this.international_transaction_fee = international_transaction_fee;
        if (transaction_fee !== undefined) this.transaction_fee = transaction_fee;
    }

    fromPayload({
        domestic_transaction_fee,
        international_transaction_fee,
        transaction_fee,
      }: Obj) {
        if (domestic_transaction_fee !== undefined) this.domestic_transaction_fee = domestic_transaction_fee;
        if (international_transaction_fee !== undefined) this.international_transaction_fee = international_transaction_fee;
        if (transaction_fee !== undefined) this.transaction_fee = transaction_fee;
        return this;
    }
}